import ModalLayout from "app/components/Layouts/ModalLayout/ModalLayout";
import React, { useState } from "react";
import styles from "./styles.module.scss";
import closeIcon from "../../../../public/images/close-icon.svg";
import UserAvatar from "app/components/UserAvatar";
import TabButton from "app/components/Button/TabButton";
import { useTranslation } from "react-i18next";
import Bookings from "./Bookings";
import ScoresAndStats from "./ScoresAndStats";
import UserModel from "app/models/UserModel";
import { formatPhoneNumber } from "app/routes/Contacts/utils";

interface Props {
  isModalOpen: boolean;
  modalHandler: () => void;
  athleteData: Partial<UserModel>;
  tabType?: TabType;
  isUSGAIntegrationActive?: boolean;
}

type TabType = "bookings" | "scores&stats";

const ScheduleModal = ({
  isModalOpen,
  modalHandler,
  athleteData,
  tabType,
  isUSGAIntegrationActive,
}: Props) => {
  const { t } = useTranslation();
  const [activeTab, setActiveTab] = useState<TabType>(tabType);

  const athleteName = athleteData.title || athleteData.fullName || `${athleteData.firstName || ''} ${athleteData.lastName || ''}`;

  const tabsList = [
    // {
    //   label: t("Spaces"),
    //   isActive: false,
    //   onClick: () => null,
    // },
    {
      label: t("Bookings"),
      isActive: activeTab === "bookings",
      onClick: () => setActiveTab("bookings"),
    },
    // {
    //   label: t("Purchases"),
    //   isActive: false,
    //   onClick: () => null,
    // }
    ...(isUSGAIntegrationActive
      ? [
          {
            label: t("USGA Scores & Stats"),
            isActive: activeTab === "scores&stats",
            onClick: () => setActiveTab("scores&stats"),
          },
        ]
      : []),
  ];

  const renderTab = () => {
    switch (activeTab) {
      case "bookings":
        return <Bookings isModalOpen={isModalOpen} athleteData={athleteData} />;
      case "scores&stats":
        return (
          <ScoresAndStats isModalOpen={isModalOpen} athleteData={athleteData} />
        );
    }
  };

  return (
    <ModalLayout
      isOpen={isModalOpen}
      onClose={modalHandler}
      wrapperClassName={styles.modal_layout_wrapper}
    >
      <div className={styles.content_wrapper}>
        <div className={styles.modal_header}>
          <div className={styles.header_title_container}>
            {(athleteData.avatar || athleteData.profilePicture || athleteData.avatarUrl) && (
              <UserAvatar
                sizeHeight={64}
                sizeWidth={64}
                altName="avatar"
                className={styles.header_logo}
                srcName={athleteData.avatar || athleteData.profilePicture || athleteData.avatarUrl}
                userName={athleteName.trim()}
              />
            )}
            <div>
              <h1 className={styles.title}>{athleteName.trim() ? athleteName.trim() : t('No Name')}</h1>
              <div className={styles.sub_title}>
                {athleteData.email && <p>{athleteData.email}</p>}
                {athleteData.phone && <p>{formatPhoneNumber(athleteData.phone)}</p>}
              </div>
            </div>
          </div>
          <img
            src={closeIcon}
            alt="close"
            className={styles.close_icon}
            onClick={modalHandler}
          />
        </div>
        <div className={styles.navbar_wrapper}>
          {tabsList.map((tab) => (
            <TabButton
              label={tab.label}
              isActive={tab.isActive}
              onClick={tab.onClick}
              key={tab.label}
            />
          ))}
        </div>

        {renderTab()}
      </div>
    </ModalLayout>
  );
};

export default ScheduleModal;
